import {NavigateOptions} from '@reach/router'
import {navigate} from 'gatsby'

import {useLocale} from '@helios/shared/providers/locale'

export interface StateProps {
    email?: string
    redirectPath?: string
    country?: string
}

const useNavigate = () => {
    const currentLocale = useLocale()

    return (to: string, options?: NavigateOptions<StateProps>) =>
        navigate(`/${currentLocale.urlCode}${to}`, options)
}

export default useNavigate
